import React, { Component } from "react";
import styled from "styled-components";
import { Button, Card, CardBody, Col, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  getMediaBuyerBudgets,
  deleteMediaBuyerBudgetByOffer,
  getMediaBuyerDataForAdd,
  addMediaBuyerBudgetsByOffer,
  getFilteredBudgets,
} from "../../../store/mediabuyers/mediabuyerbudget/actions";
import OfferMediaBuyerBudgetModal from "./components/ModalMediaBuyersBudget";
import { withRouter } from "react-router-dom";
import FormToFilter from "./../../../components/forms/FormToFilter";

class OfferMediaBuyersBudget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      filter_name: [],
      deleteAlert: null,
      viewAddBudget: false,
      budgetFilter: false,
    };
  }

  handleTableChange = data => {
    this.props.getMediaBuyerBudgets(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  toggleViewAddBudgetModal = () => {
    this.setState(prevState => ({
      viewAddBudget: !prevState.viewAddBudget,
    }));
  };

  render() {
    const onClickEdit = (e, row) => {
      this.props.history.push(
        `/offers/${this.props.offer.id}/media-buyer-budget/${row.id}/`
      );
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickEdit(e, row)}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.media_buyer}"!`,
          onConfirm: () => {
            this.props.deleteMediaBuyerBudgetByOffer(row.id, row.offer);
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <>
          {this.props.permissions?.["change_mediabuyerbudgetmodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickEdit(e, row)}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </button>
          )}
          {this.props.permissions?.["delete_mediabuyerbudgetmodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    const columns = [
      {
        dataField: "media_buyer",
        text: "Media buyer name",
        sort: true,
        formatter: (cell, row) => legalNameFormatter(cell, row, "media_buyer"),
      },
      {
        dataField: "budget",
        text: "Budget",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "budget"),
      },
      {
        dataField: "date_range",
        text: "Date range",
        sort: true,
        formatter: (e, row) => legalNameFormatter(e, row, "date_range"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <>
        {this.props.data !== null && (
          <React.Fragment>
            {this.state.viewAddBudget && (
              <OfferMediaBuyerBudgetModal
                toggle={this.toggleViewAddBudgetModal}
                isOpen={this.state.viewAddBudget}
                getData={this.props.getMediaBuyerDataForAdd}
                data={this.props.dataForAddBudget}
                currentMedia={this.props.data}
                addMediaBuyerBudget={this.props.addMediaBuyerBudgetsByOffer}
                offer={this.props.offer}
              />
            )}

            {this.state.deleteAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Delete"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle=""
                title={this.state.deleteAlert.title}
                onCancel={() => this.handleChangeDeleteAlert(null)}
                onConfirm={this.state.deleteAlert.onConfirm}
              >
                <p>Are you sure want to delete this media buyer?</p>
              </SweetAlert>
            )}
            {this.props.dataForAddBudget && (
              <FormToFilter
                data={this.props.data}
                dataForAddBudget={this.props.dataForAddBudget}
                getFilteredRequest={this.props.getFilteredBudgets}
                offerId={this.props.offer?.id}
                FilterType="budget"
                history={this.props.history}
              />
            )}

            <Row>
              <Col className="col-12">
                <Card>
                  <CardBody>
                    <RemoteTable
                      onTableChange={this.handleTableChange}
                      columns={columns}
                      data={this.props.data}
                      loading={this.props.loading}
                    >
                      {this.props.permissions?.[
                        "add_mediabuyerbudgetmodel"
                      ] && (
                        <Button
                          type="button"
                          color="success"
                          className="btn-rounded mb-2 me-2"
                          onClick={this.toggleViewAddBudgetModal}
                        >
                          <i className="mdi mdi-plus me-1" /> Add media buyer
                          budget
                        </Button>
                      )}
                    </RemoteTable>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </React.Fragment>
        )}
      </>
    );
  }
}

const LegalNameLink = styled.div`
  transition-duration: 0.1s;

  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

OfferMediaBuyersBudget.propTypes = {
  history: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  offer: PropTypes.any,
  getMediaBuyerBudgets: PropTypes.func.isRequired,
  deleteMediaBuyerBudgetByOffer: PropTypes.func.isRequired,
  getMediaBuyerDataForAdd: PropTypes.func.isRequired,
  addMediaBuyerBudgetsByOffer: PropTypes.func.isRequired,
  getFilteredBudgets: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  dataForAddBudget: PropTypes.object,
  isError: PropTypes.bool,
};

const mapStateToProps = state => ({
  data: state.MediaBuyerBudgets.data,
  dataForAddBudget: state.MediaBuyerBudgets.dataForAddBudget,
  loading: state.MediaBuyerBudgets.loading,
  permissions: state.User.permissions,
  isError: state.MediaBuyerBudgets.isError,
});

export default connect(mapStateToProps, {
  getMediaBuyerBudgets,
  deleteMediaBuyerBudgetByOffer,
  getMediaBuyerDataForAdd,
  addMediaBuyerBudgetsByOffer,
  getFilteredBudgets,
})(withRouter(OfferMediaBuyersBudget));
